<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog.active"
      :scrollable="scrollable"
      :persistent="persistent"
      :width="width"
    >
      <v-card>
        <v-card-title class="headline" v-if="noTitle">
          {{ dialog.title }}</v-card-title
        >
        <v-card-text v-if="html"> {{ dialog.text }}</v-card-text>
        <v-card-text v-if="!html" class="pt-8" v-html="dialog.text">
          {{ dialog.text }}</v-card-text
        >
        <slot name="text"></slot>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!disableDeny"
            color="primary"
            text
            @click="onDisagree()"
            >{{ deny }}</v-btn
          >
          <v-btn
            v-if="!disableApprove"
            color="primary"
            text
            @click="onAgree()"
            >{{ approve }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: Object,
    },
  },
  computed: {
    scrollable() {
      if (typeof this.dialog.options.scrollable === "undefined") {
        return false;
      }
      return this.dialog.options.scrollable;
    },
    html() {
      return !!typeof this.dialog.options.html === "undefined";
    },
    noTitle() {
      return !!typeof this.dialog.options.noTitle === "undefined";
    },
    width() {
      return typeof this.dialog.options.width === "undefined"
        ? 410
        : this.dialog.options.width;
    },
    persistent() {
      return !!typeof this.dialog.options.persistent === "undefined";
    },
    approve() {
      return typeof this.dialog.options.confirmText === "undefined"
        ? this.$t("components.dialogs.informationDialog.ok")
        : this.dialog.options.confirmText;
    },
    deny() {
      return typeof this.dialog.options.rejectText === "undefined"
        ? this.$t("components.dialogs.informationDialog.cancel")
        : this.dialog.options.rejectText;
    },
    disableApprove() {
      if (typeof this.dialog.options.disableConfirm === "undefined") {
        return false;
      }

      return this.dialog.options.disableReject;
    },
    disableDeny() {
      if (typeof this.dialog.options.disableReject === "undefined") {
        return false;
      }

      return this.dialog.options.disableReject;
    },
  },
  methods: {
    onAgree() {
      this.$emit("agree");
    },
    onDisagree() {
      this.$emit("reject");
    },
  },
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
